import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { GamePageHeaderIconButton } from '../../GamePageHeader/GamePageHeaderIconButton';
import SearchImage from '../../../../../images/game-page/search.svg';
import { useAsgActions } from '../../../../../../shared/src/hooks/use-asg-actions.hook';

export const SearchIcon = () => {
    const dispatch = useDispatch();
    const { fillCurrentGameSearchStatus } = useAsgActions();

    const onClickHandler = useCallback(
        () => dispatch(fillCurrentGameSearchStatus(true)),
        [fillCurrentGameSearchStatus]
    );

    const iconClassName = classNames(
        'game-page-header-search',
        'game-page-header-item-hoverable',
    );

    return <GamePageHeaderIconButton
        iconImage={SearchImage}
        onClick={onClickHandler}
        className={iconClassName}
    />;
};
